<template>
  <div class="main-container">
   <!-- Author: Vaishnavi
      Date: 11/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />

    <section class="main-content-section">
      <tl-tabs :tabs="tabs" :customclass="true" :showcount="false">
        <tl-tab>
            <download-template></download-template>
        </tl-tab>
        <tl-tab>
            <upload-template></upload-template>
        </tl-tab>
      </tl-tabs>
    </section>
  </div>
</template>

<script>
import DownloadTemplate from "./DownloadTemplate.vue";
import UploadTemplate from "./UploadTemplate.vue";
export default {
    components:{
        DownloadTemplate,
        UploadTemplate
    },
  data() {
    return {
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Bulk Edit Master Data",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/downloaduploadmastertemplate`
              }
        ],
      tabs: [
        {
          header: "Download Template"
        },
        {
          header: "Upload Template"
        }
      ]
    };
  },
  methods:{
    routeToMainStep(){},
    routeToSubStep(){}
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";  //margins
</style>
